import React, { memo } from 'react';
import PropTypes from 'prop-types';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import CardImage from '../Views/CardImage';

/**
 * Card for the "External Projects" listing variation - same image/title/
 * description layout as FlexFullwidthCard, plus an outbound "Visit Project"
 * CTA button (from `link_field`) like FlexNewsCard's "More info" - since
 * an External Project's whole point is usually the outward link, not (only)
 * its own internal page.
 */
const FlexExternalProjectCard = memo(
  ({ item, compact, hideLink, gridLayout }) => {
    const title = item.title ? item.title : item.id;
    const titleEl = <h4 className="cards__title">{title}</h4>;

    return (
      <div
        className={`cards__item ${gridLayout ? 'cards__item--grid' : 'cards__item--fullwidth'}`}
      >
        {!compact && (
          <CardImage
            item={item}
            fallback={'/project_default_image.svg'}
            gridLayout={gridLayout}
            href={hideLink ? undefined : item['@id']}
            speculative
          />
        )}
        <div className="cards__content">
          {hideLink ? (
            titleEl
          ) : (
            <UniversalLink href={item['@id']}>{titleEl}</UniversalLink>
          )}
          {item.description && (
            <p className="cards__description">{item.description}</p>
          )}
          {item.link_field && (
            <div className="cards__action-links">
              <a
                href={item.link_field}
                className="cards__action-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Visit Project
              </a>
            </div>
          )}
        </div>
      </div>
    );
  },
);

FlexExternalProjectCard.displayName = 'FlexExternalProjectCard';

FlexExternalProjectCard.propTypes = {
  item: PropTypes.shape({
    '@id': PropTypes.string.isRequired,
    title: PropTypes.string,
    id: PropTypes.string,
    description: PropTypes.string,
    link_field: PropTypes.string,
    image_caption: PropTypes.string,
    image_copyright: PropTypes.string,
    image_copyright_black_font: PropTypes.bool,
    image_scales: PropTypes.object,
  }).isRequired,
  compact: PropTypes.bool,
  hideLink: PropTypes.bool,
  gridLayout: PropTypes.bool,
};

export default FlexExternalProjectCard;
